import type { FC } from "react";
import { Link } from "react-router";
import { Container } from "../components/Container";

export const NotFoundPage: FC = () => (
  <Container>
    <p className="mb-4 text-neutral-500 text-xs">404</p>
    <h1 className="mb-3 font-medium text-2xl text-neutral-900 tracking-tight">
      ページが見つかりませんでした
    </h1>
    <p className="mb-8 text-neutral-500 text-sm">
      お探しのページは削除されたか、URL が変更された可能性があります。
    </p>
    <Link to="/" className="text-sm underline underline-offset-4 hover:text-neutral-900">
      マイページのトップに戻る
    </Link>
  </Container>
);
